import 'browser-environment';
import { App } from 'nospa';


import '@/styles/styles.scss';

import Counter from '@/components/Counter';
import Spoiler from '@/components/Spoiler';
import Header from '@/components/Header';
import HeaderNavItem from '@/components/HeaderNavItem';
import HeroAlert from '@/components/HeroAlert';

import '@/js/app.js';
import '@/js/news.js';
import '@/js/navigation.js';

window.App = new App({
  el: '#app',
  components: {
    CatalogFilter: () => import('@/components/CatalogFilter'),
    ProductGallery: () => import('@/components/ProductGallery'),
    Counter,
    Spoiler,
    Header,
    HeaderNavItem,
    HeroAlert,
  },
});
